// extracted by mini-css-extract-plugin
export var Section = "Management-module--Section--oCCKA";
export var Content = "Management-module--Content--EISQn";
export var Items = "Management-module--Items--8E4Jo";
export var ItemTitle = "Management-module--ItemTitle--eM7An";
export var ItemImg = "Management-module--ItemImg--hhJOn";
export var Item = "Management-module--Item--TN3Jl";
export var arrowLeft = "Management-module--arrowLeft--6bdvc";
export var arrowRight = "Management-module--arrowRight--RjwVu";